"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventHub = exports.TableProvider = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Helpers = require("../Helpers");
var _table = require("../table");
var _ykbUtils = require("ykb-utils");
var _excluded = ["expandable"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TableProvider = exports.TableProvider = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, tableRef) {
  var expandable = _ref.expandable,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var columns = props.columns,
    children = props.children;
  // prepare global table data
  var form = (0, _react.useRef)();
  var _columns = (0, _react.useRef)();
  var editMode = (0, _react.useRef)(false);
  var validationHasError = (0, _react.useRef)();
  var propsOnChangecb = (0, _react.useRef)(props.onChange);
  var _selectedRowKeys = (0, _react.useRef)([]);
  var _expandedRowKeys = (0, _react.useRef)({});
  (0, _react.useEffect)(function () {
    var preparedColumns = _Helpers.Utils.prepareTableColumn(columns, props);
    var defaultSorting = _Helpers.Utils.getDefaultSorting(preparedColumns);
    eventHub.setState({
      columns: preparedColumns,
      sortOrder: defaultSorting
    });
    eventHub.emit('update.columns', preparedColumns);

    // column degeri degisirse mevcutta secili olarak işaretlenen, focusedHighlight değerine gor row renklendirmesini kaldırmak için eklendi
    // edit mod degismesi ve uygulanan filtre degismesi durumunda, celle uygulanan focusu kaldırır
    eventHub.emit('setEditingKey&selectedDataIndex', null, null);
    var _editMode = (0, _toConsumableArray2.default)(columns).filter(function (q) {
      return q.editable;
    }).length > 0;
    if (editMode.current != _editMode) {
      eventHub.emit('update.editMode', _editMode);
      editMode.current = _editMode;
    }
    _columns.current = (0, _toConsumableArray2.default)(columns);
  }, [columns]);
  //-------------------------------

  // useEffect(() => {
  //   eventHub.emit("update.data", props.data);
  //   eventHub.setState({ data: props.data });
  // }, [props.data]);

  (0, _react.useEffect)(function () {
    eventHub.setState({
      locale: props.locale
    });
    eventHub.emit('update.locale', props.locale);
  }, []);
  (0, _react.useEffect)(function () {
    eventHub.setState({
      expandable: expandable
    });
    eventHub.emit('update.expandable', expandable);
  }, [expandable]);
  (0, _react.useEffect)(function () {
    propsOnChangecb.current = props.onChange;
  }, [props.onChange]);
  (0, _react.useEffect)(function () {
    eventHub.setState({
      focusedHighlight: props.focusedHighlight
    });
    eventHub.emit('update.focusedHighlight', props.focusedHighlight);
  }, [props.focusedHighlight]);
  (0, _react.useEffect)(function () {
    eventHub.setState({
      getRowKey: props.rowKey
    });
    eventHub.emit('update.getRowKey', props.rowKey);
  }, [props.rowKey]);
  (0, _react.useEffect)(function () {
    eventHub.setState({
      onCellChange: props.onCellChange
    });
  }, [props.onCellChange]);
  (0, _react.useEffect)(function () {
    eventHub.setState({
      rowSelection: props.rowSelection
    });
    eventHub.emit('update.rowSelection', props.rowSelection);
  }, [props.rowSelection]);
  (0, _react.useEffect)(function () {
    var _props$rowSelection;
    eventHub.on('setEditingKey&selectedDataIndex', function (key, dataIndex) {
      var previousEditingKey = eventHub.getState('editingKey');
      var previousDataIndex = eventHub.getState('selectedDataIndex');

      // changed editing cell
      if (previousEditingKey != key || previousDataIndex != dataIndex) {
        // önceki hücrenin edit modunu kapat
        var previousCellEditingId = previousEditingKey + '_' + previousDataIndex;
        eventHub.emit("isEditing.".concat(previousCellEditingId), false);

        // yeni hücrenin edit modunu aç
        var currentCellEditingId = key + '_' + dataIndex;
        eventHub.emit("isEditing.".concat(currentCellEditingId), true);
      }
      if (previousEditingKey != key) {
        // edit modda olan satır bilgisi değiştiğinde, önceki satırı kapatıp yeni satırı edit modunu açıyoruz.
        eventHub.emit("isEditing.".concat(previousEditingKey), false);
        eventHub.emit("isEditing.".concat(key), true);
      }
      eventHub.setState({
        editingKey: key,
        selectedDataIndex: dataIndex
      });
      eventHub.emit('update.editingKey', key);
      eventHub.emit('update.selectedDataIndex', dataIndex);
      eventHub.emit('update.editingKey&selectedDataIndex', key, dataIndex);
    });
    eventHub.on('update.submitingElementClassName', function (classname) {
      eventHub.setState({
        submitingElementClassName: classname
      });
    });
    if (props.rowSelection) {
      eventHub.on('update.rowSelection.onChange', /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(key, value) {
          var cachedSelectedRowKeys, response;
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                cachedSelectedRowKeys = _objectSpread({}, _selectedRowKeys.current);
                if (!(key == 'header-selection')) {
                  _context.next = 9;
                  break;
                }
                _context.next = 4;
                return eventHub.emitPromise('listen.rowSelection.change', value);
              case 4:
                response = _context.sent;
                response = response.filter(function (q) {
                  return !!q;
                });
                _selectedRowKeys.current = response.reduce(function (acc, current) {
                  acc[current] = true;
                  return acc;
                }, {});
                _context.next = 10;
                break;
              case 9:
                if (value) {
                  if (!_selectedRowKeys.current[key]) {
                    _selectedRowKeys.current[key] = true;
                  }
                } else {
                  if (_selectedRowKeys.current[key] == true) {
                    delete _selectedRowKeys.current[key];
                  }
                }
              case 10:
                if (typeof props.rowSelection.onChange == 'function' && !(0, _ykbUtils.isEqual)(cachedSelectedRowKeys, _selectedRowKeys.current)) {
                  props.rowSelection.onChange(_selectedRowKeys.current);
                }
                eventHub.setState({
                  selectedRowKeys: _selectedRowKeys.current
                });
              case 12:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
    if (typeof props.onChange == 'function') {
      eventHub.on('update.filters', /*#__PURE__*/function () {
        var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(filters) {
          var previousFilters, response, _filters;
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                // props.onChange({}, filters);
                previousFilters = eventHub.getState('filters');
                if (!(previousFilters === filters)) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return");
              case 3:
                _context2.next = 5;
                return eventHub.emitPromise('update.filters.formrow', filters);
              case 5:
                response = _context2.sent;
                response = response.filter(function (q) {
                  return !!q;
                });
                _filters = Object.keys(filters).reduce(function (acc, item, index) {
                  var filter = filters[item];
                  acc[item] = (0, _table.getValueByFilterType)(filter);
                  return acc;
                }, {});
                eventHub.setState({
                  filters: filters,
                  clientFilters: _filters
                });
                propsOnChangecb.current({}, _filters);
              case 10:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
    eventHub.setState({
      form: form,
      mode: props.mode,
      selectedRowKeys: ((_props$rowSelection = props.rowSelection) === null || _props$rowSelection === void 0 ? void 0 : _props$rowSelection.selectedRowKeys) || {},
      childrenListedGroups: props.childrenListedGroups || [],
      getInput: props.getInput || function () {
        throw new Error("getInput is not defined. This method is required.");
      },
      mapValuesFromForm: props.mapValuesFromForm || function () {
        throw new Error("mapValuesFromForm is not defined. This method is required.");
      },
      mapValuesToForm: props.mapValuesToForm || function () {
        throw new Error("mapValuesToForm is not defined. This method is required.");
      },
      editOnFocus: props.editOnFocus,
      onCellChange: props.onCellChange || function () {
        throw new Error("onCellChange is not defined. This method is required.");
      },
      setData: props.setData || function () {
        throw new Error("setData is not defined. This method is required.");
      },
      validationHasError: validationHasError,
      innerData: props.data,
      onExpandByFilter: expandable.onExpandByFilter,
      data: []
    });
    if (tableRef) {
      tableRef.current = {
        refreshData: function refreshData(_data) {
          this.reset();
          if (_data) {
            eventHub.emit('update.data', _data);
            eventHub.setState({
              data: _data
            });
          } else {
            eventHub.emit('update.data', []);
            eventHub.setState({
              data: []
            });
          }
        },
        expandedRowKeys: function expandedRowKeys(params, isIndexMode) {
          if ((0, _ykbUtils.isNullOrUndefined)(params)) {
            return _expandedRowKeys.current;
          } else if (isIndexMode) {
            var tableData = eventHub.getState('data');
            var _getByIndex = function getByIndex(children, indexes) {
              if (!children) return children;
              var _indexes = (0, _toArray2.default)(indexes),
                first = _indexes[0],
                rest = _indexes.slice(1);
              var found = children[first];
              if (indexes.length > 1) {
                if (found) {
                  return _getByIndex(found.children, rest);
                }
              }
              return found.key;
            };
            var newkeys = Object.keys(params).reduce(function (prev, value) {
              var key = _getByIndex(tableData, value.split('.'));
              prev[key] = true;
              return prev;
            }, {});
            params = newkeys;
          }
          var expandedRowKeys = (0, _toConsumableArray2.default)(Object.keys(params));
          var added = expandedRowKeys.filter(function (d) {
            return !(0, _toConsumableArray2.default)(Object.keys(_expandedRowKeys.current)).includes(d);
          });
          var removed = (0, _toConsumableArray2.default)(Object.keys(_expandedRowKeys.current)).filter(function (d) {
            return !expandedRowKeys.includes(d);
          });
          if (added.length > 0) {
            added.forEach(function (rowKey) {
              eventHub.emit("update.expandable.expandedRowKeys.".concat(rowKey), true);
            });
          }
          if (removed.length > 0) {
            removed.forEach(function (rowKey) {
              eventHub.emit("update.expandable.expandedRowKeys.".concat(rowKey), false);
            });
          }
          eventHub.setState({
            expandedRowKeys: _objectSpread({}, params)
          });
          _expandedRowKeys.current = _objectSpread({}, params);
        },
        selectedRowKeys: function selectedRowKeys(params) {
          if ((0, _ykbUtils.isNullOrUndefined)(params)) {
            return _selectedRowKeys.current;
          } else {
            var selectedRowKeys = (0, _toConsumableArray2.default)(Object.keys(params));
            var added = selectedRowKeys.filter(function (d) {
              return !(0, _toConsumableArray2.default)(Object.keys(_selectedRowKeys.current)).includes(d);
            });
            var removed = (0, _toConsumableArray2.default)(Object.keys(_selectedRowKeys.current)).filter(function (d) {
              return !selectedRowKeys.includes(d);
            });
            if (added.length > 0) {
              added.forEach(function (rowId) {
                eventHub.emit("update.rowSelection.selectedRowKeys.".concat(rowId), true);
              });
            }
            if (removed.length > 0) {
              removed.forEach(function (rowId) {
                eventHub.emit("update.rowSelection.selectedRowKeys.".concat(rowId), false);
              });
            }
            if (Object.keys(params).length == 0) {
              eventHub.emit('clear.rowSelection.selectedRowKeys');
            }
            _selectedRowKeys.current = _objectSpread({}, params);
            eventHub.setState({
              selectedRowKeys: _selectedRowKeys.current
            });
          }
        },
        getRow: function getRow(_rowKey) {
          return (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3() {
            var response;
            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return eventHub.emitPromise("get.rowData.".concat(_rowKey));
                case 2:
                  response = _context3.sent;
                  return _context3.abrupt("return", response[0]);
                case 4:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }))();
        },
        getRowId: function getRowId(_rowKey) {
          var rowKeyTree = _objectSpread({}, eventHub.getState('key2id'));
          var rowId = rowKeyTree[_rowKey];
          return rowId;
        },
        updateField: function updateField(rowkey, field, value) {
          eventHub.emit("update.row.field.".concat(rowkey), field, value);
        },
        updateRow: function updateRow(_row) {
          eventHub.emit("update.row.".concat(_row.key), _row);
          eventHub.setInnerData(_row, _row.key);
        },
        updateRowByFilter: function updateRowByFilter(_row) {
          eventHub.emit("update.row.byfilter.".concat(_row.key), _row);
          eventHub.setInnerData(_row, _row.key);
        },
        deleteRowWithId: function deleteRowWithId(rowId) {
          var tableData = this.getData();
          var deletingRow = _getRowwithId(tableData, rowId);
          eventHub.emit("isDeleted.".concat(deletingRow.key), true);
          var oldDeletes = eventHub.getState('deletedRowIds') || [];
          var oldDeleteKeys = eventHub.getState('deletedRowKeys') || [];
          eventHub.setState({
            deletedRowIds: [].concat((0, _toConsumableArray2.default)(oldDeletes), [rowId]),
            deletedRowKeys: [].concat((0, _toConsumableArray2.default)(oldDeleteKeys), [deletingRow.key])
          });
        },
        deleteRowWithKey: function deleteRowWithKey(rowKey) {
          var rowKeyTree = _objectSpread({}, eventHub.getState('key2id'));
          var rowId = rowKeyTree[rowKey];
          eventHub.emit("isDeleted.".concat(rowKey), true);
          var oldDeletes = eventHub.getState('deletedRowIds') || [];
          var oldDeleteKeys = eventHub.getState('deletedRowKeys') || [];
          eventHub.setState({
            deletedRowIds: [].concat((0, _toConsumableArray2.default)(oldDeletes), [rowId]),
            deletedRowKeys: [].concat((0, _toConsumableArray2.default)(oldDeleteKeys), [rowKey])
          });
        },
        getRowwithId: function getRowwithId(rowId) {
          var tableData = this.getData();
          var rowIdTree = _objectSpread({}, eventHub.getState('id2key'));
          var rowKey = rowIdTree[rowId];
          console.log('tablev3-log-getRowwithId', tableData, rowId, rowKey);
          return _getRowwithKey(tableData, rowId, rowKey);
        },
        getRowwithKey: function getRowwithKey(rowKey) {
          var rowPaths = _objectSpread({}, eventHub.getState('rowPaths'));
          var rowPath = rowPaths[rowKey];
          var tableData = this.getData();
          console.log('tablev3-log-getRowwithKey', tableData, rowPath);
          return _getRowwithKey(tableData, rowPath);
        },
        getParentRowwithKey: function getParentRowwithKey(rowKey) {
          var rowPaths = _objectSpread({}, eventHub.getState('rowPaths'));
          var rowPath = rowPaths[rowKey];
          var parentRowPath = rowPath.slice(0, rowPath.length - 1);
          var tableData = this.getData();
          console.log('tablev3-log-getParentRowwithKey', tableData, parentRowPath);
          return _getRowwithKey(tableData, parentRowPath);
        },
        getData: function getData(refreshData) {
          var updatedRows = eventHub.getState('updatedRows') || {};
          var deletedRows = eventHub.getState('deletedRowKeys') || [];
          var tableData = collectData(updatedRows, deletedRows);
          console.log('tablev3-log-getData', tableData, updatedRows, deletedRows);
          if (refreshData) {
            eventHub.emit('update.data', tableData);
            eventHub.setState({
              data: tableData
            });
          }
          return tableData;
        },
        clearFilters: function clearFilters() {
          eventHub.emit('update.filters', '');
          eventHub.emit('listen.rowSelection.header.change', false);
          eventHub.emit('update.rowSelection.onChange', 'header-selection', false);
        },
        clearSelectedRowsKeys: function clearSelectedRowsKeys() {
          eventHub.emit('clear.rowSelection.selectedRowKeys');
          eventHub.setState({
            selectedRowKeys: {}
          });
          _selectedRowKeys.current = [];
        },
        reset: function reset() {
          this.clearFilters();
          eventHub.setState({
            updatedRows: {},
            deletedRowKeys: [],
            deletedRowIds: [],
            key2id: {},
            id2key: {}
          });
        },
        snapshot: function snapshot(_snapshot) {
          if ((0, _ykbUtils.isNullOrUndefined)(_snapshot)) {
            var updatedRows = eventHub.getState('updatedRows') || {};
            var deletedRowKeys = eventHub.getState('deletedRowKeys') || [];
            var deletedRowIds = eventHub.getState('deletedRowIds') || [];
            var data = eventHub.getState('data') || [];
            return {
              updatedRows: updatedRows,
              deletedRowKeys: deletedRowKeys,
              deletedRowIds: deletedRowIds,
              data: data
            };
          } else {
            var _updatedRows = _snapshot.updatedRows,
              _deletedRowKeys = _snapshot.deletedRowKeys,
              _deletedRowIds = _snapshot.deletedRowIds,
              _data2 = _snapshot.data;
            eventHub.setState({
              updatedRows: _updatedRows,
              deletedRowKeys: _deletedRowKeys,
              deletedRowIds: _deletedRowIds,
              data: _data2
            });
            eventHub.emit('update.data', _data2);
          }
        },
        validateRows: function validateRows() {
          var updatedRows = eventHub.getState('updatedRows') || {};
          Object.keys(updatedRows).forEach(function (rowKey) {
            eventHub.emit("forceUpdate.".concat(rowKey));
          });
        }
      };
    }
  }, []);

  //------------------------------------
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
});
var eventHub = exports.eventHub = {
  list: new Map(),
  on: function on(eventType, eventAction) {
    var that = this;
    this.list.has(eventType) || this.list.set(eventType, []);
    if (this.list.get(eventType)) {
      var index = this.list.get(eventType).push(eventAction) - 1;
      return function () {
        // that.list.get(eventType).splice(index, 1);
        that.list.get(eventType)[index] = undefined;
      };
    }
  },
  emit: function emit(eventType) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    this.list.get(eventType) && this.list.get(eventType).forEach(function (cb) {
      if (typeof cb == 'function') {
        // console.trace(`eventhub emitting ${eventType}`, ...args);
        cb.apply(void 0, args);
      }
    });
  },
  emitPromise: function emitPromise(eventType) {
    var _arguments = arguments,
      _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _len2, args, _key2, promises, response;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            for (_len2 = _arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = _arguments[_key2];
            }
            promises = [];
            _this.list.get(eventType) && _this.list.get(eventType).forEach(function (cb) {
              promises.push(new Promise(function (resolve, reject) {
                if (typeof cb == 'function') {
                  resolve(cb.apply(void 0, args));
                }
                resolve(undefined);
              }));
            });
            _context4.next = 5;
            return Promise.all(promises);
          case 5:
            response = _context4.sent;
            return _context4.abrupt("return", response);
          case 7:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  state: new Map(),
  setState2: function setState2(cb) {
    this.state = new Map(Object.entries(cb()));
  },
  setState: function setState(params) {
    var that = this;
    Object.entries(params).forEach(function (_ref4) {
      var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];
      that.state.set(key, value);
    });
  },
  getState: function getState(key) {
    return this.state.get(key);
  },
  setInnerData: function setInnerData(row, rowKey) {
    var oldUpdates = eventHub.getState('updatedRows') || {};
    var updatedRow = (0, _defineProperty2.default)({}, rowKey, row);
    eventHub.setState({
      updatedRows: _objectSpread(_objectSpread({}, oldUpdates), updatedRow)
    });
  }
};
function collectData(updated, deleted) {
  var tableData = (0, _toConsumableArray2.default)(eventHub.getState('data'));
  var rowKeyTree = _objectSpread({}, eventHub.getState('key2id'));
  var rowPaths = _objectSpread({}, eventHub.getState('rowPaths'));
  Object.entries(updated).forEach(function (_ref6) {
    var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
      rowKey = _ref7[0],
      row = _ref7[1];
    var rowPath = rowPaths[rowKey];
    tableData = getNewData(tableData, row, rowPath);
  });
  deleted.forEach(function (rowKey) {
    var rowPath = rowPaths[rowKey];
    tableData = _deleteRowWithKey(tableData, rowPath);
  });
  return tableData;
}
function getNewData(children, updatedRow, rowPath) {
  if (!children) return children;
  var _rowPath = (0, _toArray2.default)(rowPath),
    first = _rowPath[0],
    rest = _rowPath.slice(1);
  if (rowPath.length > 1) {
    var found = children.find(function (q) {
      return q.key == first;
    });
    if (found) {
      found.children = getNewData(found.children, updatedRow, rest);
    }
  } else {
    children = children.map(function (row) {
      if (row.key == first) return updatedRow;
      return row;
    });
  }
  return children;
}
function _getRowwithId(children, rowId) {
  var indexes = rowId.split('.');
  var _indexes2 = (0, _toArray2.default)(indexes),
    first = _indexes2[0],
    rest = _indexes2.slice(1);
  var found = children[first];
  if (indexes.length > 1) {
    return _getRowwithId(found.children, rest.join('.'));
  }
  return found;
}
function _getRowwithKey(children, rowPath) {
  if (!children) return children;
  var _rowPath2 = (0, _toArray2.default)(rowPath),
    first = _rowPath2[0],
    rest = _rowPath2.slice(1);
  var found = children.find(function (q) {
    return q.key == first;
  });
  if (rowPath.length > 1) {
    if (found) {
      return _getRowwithKey(found.children, rest);
    }
  }
  return found;
}
function _deleteRowWithId(children, rowId) {
  var indexes = rowId.split('.');
  var _indexes3 = (0, _toArray2.default)(indexes),
    first = _indexes3[0],
    rest = _indexes3.slice(1);
  if (indexes.length > 1) {
    var found = children[first];
    found.children = _deleteRowWithId(found.children, rest.join('.'));
  } else {
    children.splice(first, 1);
  }
  return children;
}
function _deleteRowWithKey(children, rowPath) {
  if (!children) return children;
  var _rowPath3 = (0, _toArray2.default)(rowPath),
    first = _rowPath3[0],
    rest = _rowPath3.slice(1);
  if (rowPath.length > 1) {
    var found = children.find(function (q) {
      return q.key == first;
    });
    if (found) {
      found.children = _deleteRowWithKey(found.children, rest);
    }
  } else {
    children = children.filter(function (item) {
      return item.key != first;
    });
  }
  return children;
}
function debounce(callback, delay) {
  var timer;
  var updatedRows = {};
  return function (row, rowKey) {
    updatedRows[rowKey] = row;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback(_objectSpread({}, updatedRows));
      updatedRows = {};
    }, delay);
  };
}